export default __webpack_public_path__ + "static/women-founders-and-makers-header-5b0851309e2030abbb14151360fa3e01.svg";